import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { NEWS_API } from "./apiRoutes";

interface UseGetLatestNewsProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
  applicableCompany: string | undefined;
}

const getLatestNews = async (applicableCompany?: string) => {
  return await axiosAuth.get(
    `${NEWS_API}/?applicableCompany=${applicableCompany}`
  );
};

const useGetLatestNews = ({
  applicableCompany,
  queryParams,
}: UseGetLatestNewsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["latest-news", applicableCompany], // FIXED
    queryFn: () => getLatestNews(applicableCompany), // FIXED
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetLatestNews;
